import { Doctor } from "app/modules/masters/doctor/models/doctor.model";

export interface DoctorState {
  doctors: Doctor[];
  loading: boolean;
  error: any;
  selectedDoctor: Doctor | null;
  registrationNumberExists: boolean | null;
  altCodeExists: boolean | null;
  total: number;
  searchResultsByRow: { [rowIndex: number]: Doctor[] };
}

export const initialDoctorState: DoctorState = {
  doctors: [],
  loading: false,
  error: null,
  selectedDoctor: null,
  altCodeExists: false,
  registrationNumberExists: false,
  total: 0,
  searchResultsByRow: {},
};
